<pr-interactions
  editable
  [compact]="compact$ | async"
  [enableScroll]="enableScroll$ | async"
  [interactions]="interactions$ | async"
  [pinnedInteractions]="pinnedInteractions$ | async"
  [useEditor]="false"
  (interactionAdded)="addInteraction($event)"
  (interactionUpdated)="updateInteraction($event)"
  (interactionDeleted)="deleteInteraction($event)"
/>
